import React from 'react';
import styled from 'styled-components';
import { Icon } from '@iconify/react';
import documentPdf from '@iconify/icons-carbon/document-pdf';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
`;

const VerticalSelectItem = styled.div<{ selected: boolean }>`
  padding: 5px 10px;
  display: flex;
  color: ${props => props.selected? '#FFFFFF' : '#292D34'};
  background: ${props => props.selected? '#233567' : '#FFFFFF'};
`;

const ItemIcon = styled.div`
  padding: 5px;
`;

const ItemText = styled.div`
  font-size: 14px;
  padding: 10px;
`;

export const VerticalSelect = ({ selected, options, onClick }: { selected: number, options: any; onClick?: Function }) => {
  
  return (
    <Container>
      {options.map(option => (
        <VerticalSelectItem selected={option.id === selected}>
          <ItemIcon>
            <Icon width={25} icon={documentPdf} />
          </ItemIcon>
          <ItemText>
            {option.text}
          </ItemText>
        </VerticalSelectItem>
      ))}
    </Container>
  )
}